
const ReadOnlyField = ({rec, fld, label=null, size=20}) => {
    if (!label) {
        return (
            <input type="text" value={rec[fld]} size={size} readOnly={true} disabled={true} />
        )
    }
    return (
        <label> {label}:
            <input type="text" value={rec[fld]} size={size} readOnly={true} disabled={true} />
        </label>
    )
}

export default ReadOnlyField